import { render, staticRenderFns } from "./NoHeaderLayout.vue?vue&type=template&id=09c21988"
import script from "./NoHeaderLayout.vue?vue&type=script&lang=ts"
export * from "./NoHeaderLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports